module.exports = __webpack_public_path__ + "img/等级回升-灰.49bfd7a7.png";